<!-- eslint-disable max-len -->
<template>
  <div id="app" class="container-fluid">
    <b-navbar type="dark" variant="dark">
      <b-navbar-brand v-if="loggedIn" href="#">
        <a v-b-toggle.sidebar href="#">
          <font-awesome-icon icon="bars" class="text-white" fixed-width />
        </a>
      </b-navbar-brand>
      <b-nav-text href="#" class="text-white">Acorn</b-nav-text>
      <div class="mx-auto">
        <b-navbar-brand class="header-profile">
          <template v-if="showCurrentSiteLink()">
            <template v-if="currentRoute() === 'SiteVisit'">
              First Site Visit:
            </template>
            <template v-if="currentRoute() === 'SiteAssessment'">
              Site Assessment:
            </template>
            <router-link :to="{ name: 'Site', params: { id: currentSite.Id } }">
              {{ currentSite.RecordName }}
            </router-link>
            <span v-if="currentRoute() === 'SiteAssessment' && siteAssessment && siteAssessment.status">
              ({{siteAssessment.status}})
            </span>
          </template>
        </b-navbar-brand>
      </div>
      <b-nav-item-dropdown class="header-profile" text="" right>
        <template slot="button-content">
          <span>
            <span v-if='loggedIn'>Hello, {{loggedInUserName}}&nbsp;</span>
            <span v-else>Not Signed In&nbsp;</span>
            <img src="/img/profile.svg"/>
          </span>
        </template>
        <b-dropdown-item v-if='loggedIn' href="#" @click="signOut">Sign Out</b-dropdown-item>
        <b-dropdown-item>Version: {{getVersion}}</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar>
    <div class="row primary-row">
      <div class="col-4 navbar-bottom-border-1"></div>
      <div class="col-4 navbar-bottom-border-2"></div>
      <div class="col-4 navbar-bottom-border-3"></div>
    </div>
    <div class="row primary-row">
      <b-collapse id="sidebar" v-if="loggedIn"
      accordian="test-accordian" class="col-2">
        <ul class="side-panel-list">
          <li>
            <router-link
              :to="{ name: 'Dashboard' }"
              exact
              class="side-panel-item"
              active-class="router-link-active">
              <img class="side-panel-icon" src="/img/dashboard.svg"/>
              <span class="side-panel-label"> Dashboard</span>
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'MySites' }"
              class="side-panel-item"
              active-class="router-link-active">
              <img class="side-panel-icon" src="/img/home.svg"/>
              <span class="side-panel-label"> Downloaded Sites</span>
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'NewProjectsBudgetStatus' }"
              class="side-panel-item"
              active-class="router-link-active">
              <img class="side-panel-icon" src="/img/projectBudgetStatus.svg"/>
              <span class="side-panel-label"> New Project Budgets</span>
            </router-link>
          </li>
          <li
            v-if="isExportBillsUser">
            <router-link
              :to="{ name: 'ExportBills' }"
              class="side-panel-item"
              active-class="router-link-active">
              <img class="side-panel-icon" src="/img/exportBills.svg"/>
              <span class="side-panel-label"> Export Bills</span>
            </router-link>
          </li>
          <li
            v-if="isAdmin">
            <router-link
              :to="{ name: 'Admin' }"
              class="side-panel-item"
              active-class="router-link-active">
              <img class="side-panel-icon" src="/img/admin-grayBg1.svg"/>
              <span class="side-panel-label"> Admin Page</span>
            </router-link>
          </li>
        </ul>
      </b-collapse>
      <div class="col primary-content"><router-view/></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-console, padded-blocks */
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    loggedInUserName() {
      return this.$store.getters['User/getCurrentUser'].name;
    },
    ...mapState(['currentSite', 'config']),
    ...mapGetters(['getVersion']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    ...mapState('SiteAssessment', {
      siteAssessment: (state) => state.siteAssessment,
    }),
    isExportBillsUser() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const viewerRoles = this.config.dashboardPage.exportBillsRoles;
      return this.memberOf.find((item) => viewerRoles.includes(item.displayName));
    },
    isAdmin() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const viewerRoles = this.config.dashboardPage.adminRoles;
      return this.memberOf.find((item) => viewerRoles.includes(item.displayName));
    },
  },
  data() {
    return {
      loggedIn: false,
      unsubscribeSetUser: null,
    };
  },
  async mounted() {
    this.$store.dispatch('Membership/fetchMemberOf');
    this.$store.dispatch('fetchVersion');
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      this.$store.dispatch('setShowSidePanel', isJustShown);
    });
    this.unsubscribeSetUser = this.$store.subscribe(async (mutation) => {
      if (mutation.type === 'User/SET_USER') {
        if (this.$store.getters['User/getCurrentUser'] != null) {
          this.loggedIn = true;
        }
      }
    });
    this.getLoggedInStatus();
  },
  methods: {
    getLoggedInStatus() {
      return this.$msal.isAuthenticated;
    },
    showCurrentSiteLink() {
      return this.currentSite
        && ['SiteVisit', 'SiteAssessment'].includes(this.currentRoute());
    },
    currentRoute() {
      return this.$route.name;
    },
    signOut() {
      this.$msal.signOut(this.$router);
    },
  },
};
</script>
